/**
 * Centralized configuration for the application.
 * Reads build-time environment variables (provided by webpack) to allow different
 * backend targets for development vs. staging/production builds.
 */

// This global is injected by webpack DefinePlugin during the build; Excel WebView never sees `process`.
//declare const __REACT_APP_API_BASE_URL__: string | undefined;
declare const __BACKEND_API_BASE_URL__: string | undefined;
declare const __LOCAL_DEV_MODE__: string | undefined;

const isLocalhostHostname = (hostname?: string): boolean => {
  if (typeof hostname !== "string") {
    return false;
  }
  return hostname === "localhost" || hostname === "127.0.0.1";
};

const normalizeBaseUrl = (raw?: string): string | undefined => {
  if (typeof raw !== "string") {
    return undefined;
  }
  const trimmed = raw.trim();
  return trimmed.replace(/^['"]+/, "").replace(/['"]+$/, "");
};

const normalizeBooleanFlag = (raw?: string): boolean => {
  if (typeof raw !== "string") {
    return false;
  }
  const trimmed = raw
    .trim()
    .replace(/^['"]+/, "")
    .replace(/['"]+$/, "");
  return trimmed.toLowerCase() === "true";
};

const localDevModeRaw = typeof __LOCAL_DEV_MODE__ !== "undefined" ? __LOCAL_DEV_MODE__ : "";
let buildTimeApiBaseUrl = normalizeBaseUrl(__BACKEND_API_BASE_URL__);
const isLocalDevMode = normalizeBooleanFlag(localDevModeRaw);
const runtimeHostname =
  typeof window !== "undefined" && window.location ? window.location.hostname : undefined;
const isRuntimeLocalhost = isLocalhostHostname(runtimeHostname);

if (isLocalDevMode) {
  buildTimeApiBaseUrl = "https://localhost:8000";
  if (typeof console !== "undefined" && typeof console.info === "function") {
    console.info(
      "[config] LOCAL_DEV_MODE active; forcing API_BASE_URL to https://localhost:8000 (raw flag value:",
      localDevModeRaw,
      ")"
    );
  }
} else {
  buildTimeApiBaseUrl = normalizeBaseUrl(__BACKEND_API_BASE_URL__);
  if (typeof console !== "undefined" && typeof console.info === "function") {
    console.info(
      "[config] LOCAL_DEV_MODE inactive; using build-time BACKEND_API_BASE_URL:",
      buildTimeApiBaseUrl,
      "(raw flag value:",
      localDevModeRaw,
      ")"
    );
  }
}

if (!buildTimeApiBaseUrl) {
  if (isRuntimeLocalhost) {
    buildTimeApiBaseUrl = "https://localhost:8000";
  } else {
    throw new Error(
      "BACKEND_API_BASE_URL must be set for non-local builds (refusing to fall back to localhost)."
    );
  }
}

export const API_BASE_URL = buildTimeApiBaseUrl;
export const LOCAL_DV_MODE = isLocalDevMode;
